<script lang='ts'>
  interface Props {
    norm: string
  }

  const { norm }: Props = $props();
</script>

<div>
  {norm}
</div>

<style lang='scss'>
  @use '@otto-ec/design-tokens/tokens';

  div {
    font: tokens.$oc-semantic-font-headline-10;
    color: tokens.$oc-semantic-color-text-secondary;
    padding: 6px 4px 6px 4px;
    white-space: nowrap;
    text-decoration: var(--tile-hover-decoration-grey);
  }
</style>
